import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

import Table from "./../../../components/common/Table";
import Pagination from "./../../../components/common/Pagination";
import Toaster from "./../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";
import moment from "moment";

const TaxIndexesTable = ({ data, columns, options, onChange, setData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDeadlines = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await complianceService.getCORDeadlinesAsync(options);
        const { result, page, total_count } = response;

        const items = result.map((item) => {
          item["deadline"] = moment(item.end_date).format("MMM DD, yyyy");
          item["status_type"] = item.status_type ?? "-";
          item["account_name"] = (
            <Link
              className="hover:text-blue-400"
              to={`/accounts/${item.account_id}`}
            >
              {item.account_name}
            </Link>
          );

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [options, setData]
  );

  const handleSort = (sort_column) => {
    const new_options = { ...options };
    new_options.sort_column = sort_column;
    onChange(new_options);
  };

  const handlePageChange = (page) => {
    const new_options = { ...options };
    new_options.current_page = page;
    onChange(new_options);
  };

  useEffect(() => {
    let mounted = true;

    fetchDeadlines(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchDeadlines]);

  return (
    <div className="mt-10 overflow-auto">
      <Table
        data={data}
        columns={columns}
        sortColumn={options.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={options.size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TaxIndexesTable;
